import {
	defaultFetchState,
	fetchRequested,
	fetchFailed,
	fetchSuccess,
	defaultSaveState,
	saveRequested,
	saveFailed,
	saveSuccess,
} from "utils";

import * as fromTypes from "../actions/types";
import * as fromOrgTypes from "features/organisations";

const defaultState = {
	numberOfRecords: {},
	siteNumberOfRecords: {},
    allowExternalNotifications: false,
    leaveHoursPerDay: 8,
	...defaultFetchState,
	...defaultSaveState,
};

const profile = (state = defaultState, action) => {
	switch (action.type) {
		case fromTypes.PROFILE_RESET:
			return defaultState;
		case fromOrgTypes.ORGANISATIONS_CURRENT_ORGANISATION_CHANGED:
		case fromTypes.PROFILE_FETCH:
			return fetchRequested(state);
		case fromTypes.PROFILE_FETCH_FAILED:
			return fetchFailed(state, action.payload);
		case fromTypes.PROFILE_FETCH_SUCCESS:
			return {
				...fetchSuccess(state),
				...addProfile(state, action),
			};
		case fromTypes.PROFILE_SAVE:
			return {
				...saveRequested(state),
				...addProfile(state, action),
			};
		case fromTypes.PROFILE_SAVE_FAILED:
			return saveFailed(state, action.payload);
		case fromTypes.PROFILE_SAVE_SUCCESS:
			return saveSuccess(state);
		default:
			return state;
	}
};

const addProfile = (state, action) => {
	const getProperty = (key) => action.payload[key] || "";

	const { password, ...rest } = action.payload;
	const email = getProperty("email");
	const phone = getProperty("phone");
	const firstName = getProperty("firstName");
	const lastName = getProperty("lastName");
	const fullName = String(`${firstName} ${lastName}`).trim();
	const staffId = getProperty("staffId");
    let allowExternalNotifications = getProperty("allowExternalNotifications");
	const supervisingStaffList = getProperty("supervisingStaffList");
    let leaveHoursPerDay = action.payload["leaveHoursPerDay"];

    // Coerce to a strict boolean; default to false when empty/undefined/null
    allowExternalNotifications =
        allowExternalNotifications === "" ? false : Boolean(allowExternalNotifications);

    // Default to 8 hours when not provided or invalid
    leaveHoursPerDay = Number.isFinite(leaveHoursPerDay) ? leaveHoursPerDay : 8;

	return {
		...rest,
		email,
		phone,
		firstName,
		lastName,
		fullName,
		staffId,
		supervisingStaffList,
		allowExternalNotifications,
		leaveHoursPerDay,
	};
};

export default profile;
